export default "__VITE_ASSET__C9Lng_9Q__"